import FormErrorMessage from 'components/FormErrorMessage';
import get from 'lodash/get';

const RadioField = ({
  enableValidation,
  block,
  input,
  id,
  msg,
  meta: { touched, error },
  className,
}) => {
  const handleBlur = () => input.onBlur();
  return (
    <div className={block ? 'block' : 'inline-block'}>
      <input
        {...input}
        id={id}
        className={className}
        type='radio'
        onBlur={handleBlur}
      />
      {enableValidation && touched && error && (
        <FormErrorMessage>{get(msg, ['validation', error])}</FormErrorMessage>
      )}
    </div>
  );
};

export default RadioField;
